import BaseTablesRepository from '@base/features/game/model/baseTableRepository';
import { TableOptions } from '@base/features/game/model/interfaces';
import Table from './table';

export default class TableRepository extends BaseTablesRepository<Table> {
  add(options: TableOptions): Table {
    const newTable = Object.assign(new Table(), options);
    this.tables.next(this.tables.value.concat(newTable));
    return newTable;
  }
}
